import { useEffect } from 'react';

/**
 * Custom hook to handle table hover without affecting fixed columns
 * This is a workaround for Ant Design's fixed column hover overlap issue
 */
export const useTableHover = () => {
  useEffect(() => {
    let listenersAdded = false;
    let handleMouseOver = null;
    let handleMouseOut = null;

    // Wait for DOM to be ready and table to be rendered
    const timer = setTimeout(() => {
      handleMouseOver = (e) => {
        const cell = e.target.closest('td');
        if (!cell) return;

        const row = cell.closest('tr');
        if (!row || !row.classList.contains('ant-table-row')) return;

        // Get all cells in the row
        const cells = row.querySelectorAll('td');

        cells.forEach(td => {
          // Check if cell has any 'fix' class
          const hasFixedClass = Array.from(td.classList).some(className =>
            className.includes('fix')
          );

          // Only apply hover to non-fixed cells
          if (!hasFixedClass) {
            td.style.setProperty('background-color', 'rgba(254, 2, 125, 0.08)', 'important');
          } else {
            // Ensure fixed columns stay white
            td.style.setProperty('background-color', 'rgb(229, 243, 247)', 'important');
          }
        });
      };

      handleMouseOut = (e) => {
        const cell = e.target.closest('td');
        if (!cell) return;

        const row = cell.closest('tr');
        if (!row || !row.classList.contains('ant-table-row')) return;

        // Get all cells in the row
        const cells = row.querySelectorAll('td');

        cells.forEach(td => {
          // Check if cell has any 'fix' class
          const hasFixedClass = Array.from(td.classList).some(className =>
            className.includes('fix')
          );

          // Reset non-fixed cells
          if (!hasFixedClass) {
            td.style.removeProperty('background-color');
          } else {
            // Keep fixed columns white always
            td.style.setProperty('background-color', 'rgb(229, 243, 247)', 'important');
          }
        });
      };

      // Add event listeners using event delegation on document
      document.addEventListener('mouseover', handleMouseOver);
      document.addEventListener('mouseout', handleMouseOut);
      listenersAdded = true;
    }, 500); // Give table time to render

    // Cleanup function
    return () => {
      clearTimeout(timer);
      if (listenersAdded && handleMouseOver && handleMouseOut) {
        document.removeEventListener('mouseover', handleMouseOver);
        document.removeEventListener('mouseout', handleMouseOut);
      }
    };
  }, []);
};
